import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] ${light ? "text-[#e9c9a8]" : "text-[#a4532f]"}`}>
    <span className={`h-px w-10 ${light ? "bg-[#e9c9a8]" : "bg-[#a4532f]"}`} />
    {children}
  </p>
);
